
<script lang="ts">
import { onMount } from "svelte";
import { navigate } from "svelte-navigator";
import Footer from "../components/Footer.svelte";
import ParkingTime from "../components/ParkingTime.svelte";
import SelectCar from "../components/selectCar.svelte";
import type { Car } from "../Model/Car";
import type { Client } from "../Model/Client";
import type { Parking } from "../Model/Parking";
import { carService, parkingService, parkingStorageService } from "../services";
import { getCurrentUser, isLoggedIn } from "../services/session";

let client: Client;
let cars: Car[]; 
let parking: Parking; 
let viewParking: Boolean = false;

onMount(() => {
    if (!isLoggedIn()) {
      navigate('/login')
      return;
    }
  
    client = getCurrentUser();
  
    downloadParking();
})

function onParkingSolved(){
  viewParking = false
}


async function downloadParking(){

  parking = await parkingService.getParkingActiveByClientId(client.id.value);

  viewParking = true;
}

</script>

{#if viewParking}
  <ParkingTime parking={parking} on:parkingSolved={onParkingSolved} />
{:else}
  <SelectCar />
{/if}


<Footer/>